import { uid } from 'quasar';

export function getShortUID() {
  return uid().substr(-5);
}
